import { createApp } from 'vue'
import FButton from '~/js/components/button'
import FProductCard from '~/js/components/productCard'
import { isDesktop } from '~/js/templates/index/helpers'
import { getItemsFromIds, getRecentProductIds } from '~/js/helpers/getProducts'

const ID = 'js-pages-recent'

document.addEventListener('DOMContentLoaded', async () => {
  const element = document.getElementById(ID)
  if (!element) return

  const recentProductIds = getRecentProductIds()

  const getProducts = async () => {
    return await getItemsFromIds(recentProductIds)
  }

  let products = []
  let hasError = false
  try {
    products = await getProducts()
  } catch {
    hasError = true
  }

  createApp({
    name: 'PagesRecent',
    components: {
      FButton,
      FProductCard,
    },
    data() {
      return {
        hasError,
        isProcessing: false,
        products: products.filter((v) => v),
        size: isDesktop() ? undefined : 'small',
      }
    },
    methods: {
      async retry() {
        this.isProcessing = true
        try {
          this.products = await getProducts()
          this.hasError = false
        } catch (e) {
          this.hasError = true
          console.error(e)
        }
        this.isProcessing = false
      },
    },
  }).mount(element)
})
